module.exports = __webpack_public_path__ + "img/icon-fishing-white.b5d42ac5.svg";